
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from 'react'
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useAddShipmentFDMutation } from "store/services/shipmentFulfillmentDocumentApi";

import ShipmentFulfillmentDocumentForm from "./ShipmentFulfillmentDocumentComponents/ShipmentFulfillmentDocumentForm";

import { useAppMeta } from "hooks";

const ShipmentFulfillmentDocumentCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment Document", path: "/app/crm/collection-document/list" },
    { title: "New Shipment Document" },
  ];

  // RTK Query
  const [createShipmentFD, { isLoading: creatingShipmentFD }]
    = useAddShipmentFDMutation();

  // methods
  const handelCreateShipmentFD = async (data) => {

    try {
      const { _id } = await createShipmentFD(data).unwrap();
      toast.success("Shipment Document is Created !");
      navigate(`/app/crm/collection-document/${_id}/detail`)
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Shipment Document !"
      );
    }
  };

  useAppMeta("New Shipment Document");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipmentFD}>
      <BreadcrumbLayout.Paper>
        <ShipmentFulfillmentDocumentForm isBusy={creatingShipmentFD} onSubmit={handelCreateShipmentFD} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default ShipmentFulfillmentDocumentCreateScreen